import { apiService } from './api';
import type { LessonPlanFolder, LessonPlanFolderFormData } from '../types';

export class LessonPlanFolderService {
  private baseUrl = '/api/lesson-plan-folders';

  async getFolders(): Promise<LessonPlanFolder[]> {
    const data = await apiService.get<{ folders: LessonPlanFolder[] }>(this.baseUrl);
    return data.folders || [];
  }

  async createFolder(formData: LessonPlanFolderFormData): Promise<LessonPlanFolder> {
    return apiService.post<LessonPlanFolder>(this.baseUrl, formData);
  }

  async updateFolder(id: string, formData: LessonPlanFolderFormData): Promise<LessonPlanFolder> {
    return apiService.put<LessonPlanFolder>(`${this.baseUrl}/${id}`, formData);
  }

  async deleteFolder(id: string): Promise<void> {
    return apiService.delete<void>(`${this.baseUrl}/${id}`);
  }

  async moveLessonPlanToFolder(lessonPlanId: string, folderId: string | null): Promise<{ success: boolean; folderId: string | null }> {
    return apiService.patch<{ success: boolean; folderId: string | null }>(`/api/lesson-plans/${lessonPlanId}/folder`, {
      folderId
    });
  }

  async bulkMoveLessonPlansToFolder(lessonPlanIds: string[], folderId: string | null): Promise<{ success: boolean; movedCount: number; message?: string; count?: number; errors?: Array<{ id: string; error: string }> }> {
    return apiService.patch<{ success: boolean; movedCount: number; message?: string; count?: number; errors?: Array<{ id: string; error: string }> }>('/api/lesson-plans/bulk-move-to-folder', {
      ids: lessonPlanIds,
      folderId
    });
  }
}

export const lessonPlanFolderService = new LessonPlanFolderService();

